import Store from "../../../../Store/Store";

class ChargeClassContainer {
  public pickIdFromLabel(label) {
    const chargeClass = Store.getConfigurator().getState().globalTypes?.ChargeClass;
    for(const key in chargeClass) {
      if (chargeClass[key].label?.toLowerCase() === label?.toLowerCase()) {
        return chargeClass[key].id
      }
    }
  }
  public pickLabelFromId(id) {
    const chargeClass = Store.getConfigurator().getState().globalTypes?.ChargeClass;
    for(const key in chargeClass) {
      if (chargeClass[key].id === id) {
        return chargeClass[key].label
      }
    }
  }
}

export default new ChargeClassContainer();
